import { Building2, User } from 'lucide-react'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from 'components'
import { LINKEDIN_CONNECT_OPTIONS, type LinkedInMode } from 'modules/oauth/utils/linkedin-connect'

// Personal-vs-Company-Page chooser shown when connecting LinkedIn (the single
// LinkedIn card fronts both providers). Built on the T3 `dark` Dialog. Cancelling
// (Esc / overlay / close) simply closes — no OAuth opens.
export function LinkedInConnectChooser({
  open,
  onOpenChange,
  onChoose,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  onChoose: (mode: LinkedInMode) => void
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent variant="dark" size="sm">
        <DialogHeader>
          <DialogTitle variant="dark">Connect LinkedIn</DialogTitle>
          <DialogDescription variant="dark">
            Choose where Taka should publish on LinkedIn.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2 space-y-2">
          {LINKEDIN_CONNECT_OPTIONS.map(option => (
            <button
              key={option.mode}
              type="button"
              onClick={() => onChoose(option.mode)}
              className="flex w-full items-center gap-3 rounded-[10px] border border-line bg-bg-3 p-3 text-left transition-colors hover:border-line-bright"
            >
              <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-bg-2">
                {option.mode === 'personal' ? (
                  <User size={18} className="text-paper-dim" />
                ) : (
                  <Building2 size={18} className="text-paper-dim" />
                )}
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium text-paper">{option.title}</p>
                <p className="text-xs text-paper-dim">{option.description}</p>
              </div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
